
import { Vue, Component } from "vue-property-decorator";
import { Loading } from "vant";
import request from "@/api/index";

@Component({
  components: {
    "van-loading": Loading
  }
})
export default class index extends Vue {
  msg = "校验中...";

  async created() {
    try {
      const query = this.$route.query;
      const { "dcqc-tk": sjzlToken, pjCode, appId } = query;
      const payload: any = { sjzlToken, pjCode, appId };
      const res: any = await request.fetchUserInfoBySjzl(payload);
      if (!res.code) {
        this.msg = "校验成功，跳转中...";
        window.location.href = res.data;
      } else {
        this.msg = "校验失败，" + res.message;
      }
    } catch (e) {
      this.msg = "校验失败，网络异常";
    }
  }
}
